export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/logo.jpg"
    alt="Logo PureTextiles"
    className={`${className} rounded-full bg-white object-cover ring-1 ring-slate-200`}
  />
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span
      className={`font-serif text-xl font-semibold tracking-tight ${
        dark ? "text-white" : "text-slate-900"
      }`}
    >
      Pure<span className="text-teal-600">Textiles</span>
    </span>
  </span>
);
